export const routerPath = [
  "/api/statistics/school/v1/report",
  "/form/dataTemplate/v1/listJson",
  "/uc/tenantManage/v1/getTenantByCode",
];
